import React, {Component, Fragment} from 'react';
import { inject, observer } from 'mobx-react';
import { withFirebase } from '../../../services/Firebase';

import { Card, Col, CardHeader, CardTitle, CardBody, Button } from 'reactstrap';
import { Star } from "react-feather"
import "../../../assets/scss/pages/app-chat.scss";
import { Link } from 'react-router-dom';
import processingImg from '../../../assets/img/pages/maintenance.png'


@inject('dashboardStore')
@observer
class LatestContent extends Component {

  componentDidMount() {
    let { dashboardStore } = this.props;
    dashboardStore.setDocumentFilter({category: 'ALL'})
    dashboardStore.loadDocuments();
  }

  renderData = () => {
    let { dashboardStore } = this.props;
    const {documentCollection, activitiesCollection} = dashboardStore;
    const { activities } = activitiesCollection;
    let data = documentCollection.documents;
    var content = data.slice(0, 4); // Remove this method and make a call for only 4 items
    return (
      content && content.map((item, index) => {
        return (
          <Card
            className="_content-card"
            key={index}>
            <div className="card-content">
              <div className="card-tag">
                {
                  item.contentType
                    ? <span className="text-capitalize">{item.contentType}</span>
                    : <span>--NA--</span>
                }
              </div>
              <div className="item-img d-flex align-items-center justify-content-center">
                {
                  item.conversionStatus == "PENDING" || item.conversionStatus == "ERROR"
                    ?
                    <img
                      className="img-fluid theme-bg-img"
                      src={processingImg}
                      alt={item.name}
                    />
                    : <img
                      className="img-fluid"
                      src={item.file.thumbUrl}
                      alt={item.name}
                    />
                }
              </div>
              <CardBody>
                <div>
                  <div className="item-name mb-1">
                    <span >{item.name}</span>
                  </div>
                  <div className="card-item-wrapper">
                    <div className="item-rating mr-2">
                      <Star fill="#7367f0" color="#7367f0" size={15} />
                      <Star fill="#7367f0" color="#7367f0" size={15} />
                      <Star fill="#7367f0" color="#7367f0" size={15} />
                      <Star fill="#7367f0" color="#7367f0" size={15} />
                    </div>
                    {
                      item.readTime
                        ? <div className="read-time">
                          <span>( {item.readTime} mins )</span>
                        </div>
                        : null
                    }
                  </div>
                </div>
              </CardBody>
            </div>
          </Card>
        )
      })
    );
  }

  renderLoading = () => {
    return (
      [1, 2, 3, 4].map((item, index) => {
        return (
          <Card
            className="_content-card"
            key={index}>
            <div className="card-content">
              <div style={{height: "150px", backgroundColor: "#eee"}}>
              </div>
              <CardBody>
                  <div className="mb-1" style={{ width: "100%", height: "12px", backgroundColor: "#eee" }}></div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <Star fill="#eee" color="#eee" size={15} />
                      <Star fill="#eee" color="#eee" size={15} />
                      <Star fill="#eee" color="#eee" size={15} />
                      <Star fill="#eee" color="#eee" size={15} />
                    </div>
                    <span style={{ width: "20%", height: "8px", backgroundColor: "#eee" }}></span>
                  </div> 
              </CardBody>
            </div>
          </Card>
        )
      })
    )
  }

  render() {
    let { dashboardStore } = this.props;
    let {isDownloading} = dashboardStore;
    return (
        <div className="content-flex">
          {
            isDownloading
            ? this.renderLoading()
            : this.renderData()
          }
        </div>
    )
  }
}

export default LatestContent;